import * as React from "react";
import Modal from "../ModalWindow/Modal";
import styles from "./InfoIcon.module.scss";
import {PropsWithChildren} from "react";

const InfoIcon: React.FC<PropsWithChildren> = (props) => {
  const [open, setOpen] = React.useState<boolean>(false);

  return (
    <span className={`${styles.wrapper} icon icon-info`} onClick={() => setOpen(true)}>
      <Modal isVisible={open} closeFunction={() => setOpen(false)}>
        {props.children}
      </Modal>
    </span>
  );
};

export default InfoIcon;
